import { vehicleTypes } from "@/utils/functions";
import BuyVehicleView from "./view";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useVehicles from "@/hooks/register/useVehicles";
import { PropsSet, PropsView } from "./Models";
import useCybersourceService from "@/hooks/useCybersourceService";
import useVehicleForm from "@/hooks/useVehicleForm";

export default function BuyVehicle() {

  const navigate = useNavigate();

  const { addCyberSourceScripts, getSessionId } = useCybersourceService();

  const [vehicleInfos, setVehicleInfos] = useState<{
    brandName?: string;
    modelName?: string;
  } | null>(null);

  const resetFields: (fields: string[], set: PropsSet['set']) => void = (fields, set) => {
    fields?.map(item => set(item as "type" | "brand" | "model", "0", { shouldValidate: true }));
  };

  const { requestBrands, requestModels, data, isLoadingOrdering } = useVehicles();

  const {
    toggleModal,
    isVisibleModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    errors,
    handlePlate,
    error,
    errorPlate,
    control,
    setValue,
    getValues,
    success,
    errorCreateVehicle,
  } = useVehicleForm({
    navigate,
    resetFields,
    getVisitorId: getSessionId,
    isLogged: true,
    vehicleInfos: vehicleInfos!,
  });

  const goBack = () => navigate(-1);

  const onChangeSelect: PropsView['onChangeSelect'] = ({ e, onChange }) => {
    onChange(e);

    const { name, value, options, selectedIndex } = e.target;

    const text = options?.[selectedIndex]?.text;

    let fields: Array<"type" | "brand" | "model"> = [];

    switch (name) {
      case "type":
        fields = ["brand", "model"];
        if (value !== "0") {
          requestBrands(value);
        }
        break;

      case "brand":
        fields = ["model"];
        if (value !== "0") {
          setVehicleInfos(prev => ({ ...prev, brandName: text }));
          requestModels(getValues("type"), value);
        }
        break;

      case "model":
        if (value !== "0") {
          setVehicleInfos(prev => ({ ...prev, modelName: text }));
        }
        break;

      default:
        break;
    }

    resetFields(fields, setValue as PropsSet['set']);
  }

  useEffect(() => {
    addCyberSourceScripts();
  }, []);

  return <BuyVehicleView
    goBack={goBack}
    onChangeSelect={onChangeSelect}
    isDisabled={isDisabled}
    types={vehicleTypes}
    brands={data?.brands as PropsView['brands']}
    models={data?.models as PropsView['models']}
    isLoading={isLoading || isLoadingOrdering}
    error={error}
    errorPlate={errorPlate}
    handlePlate={handlePlate}
    errorCreateVehicle={errorCreateVehicle}
    success={success}
    register={register}
    control={control}
    isVisibleModal={isVisibleModal}
    toggleModal={toggleModal}
    errors={errors}
    handleSubmit={handleSubmit}
  />;
}
